import titleBarTheme from "./titleBarTheme";
// import mtaKeyAllowCheck from "./mta/index";
let lastTitleBarTheme = null;
export default {
  send(msg, callback) {
    let bridge = window.WebViewJavascriptBridge;
    bridge && bridge.send(msg, callback);
  },
  sendPageAction(url, type, action, theme) {
    if (!url.startsWith("http"))
      url = location.protocol + "//" + location.host + url;
    type = type || "post";
    this.send({ url, type, action, theme: theme || {} });
    /* if (location.hostname === 'localhost') {
            let arr = [], { productKey, token, lang, webTheme } = window.PAGE_PARAMS || {};
            if (url.indexOf('productKey=') < 0 && productKey) arr.push('productKey=' + productKey);
            if (url.indexOf('token=') < 0 && token) arr.push('token=' + token);
            if (url.indexOf('lang=') < 0 && lang) arr.push('lang=' + lang);
            if (url.indexOf('webTheme=') < 0 && webTheme) arr.push('webTheme=' + webTheme);
            if (arr.length) {
                url += url.indexOf('?') < 0 ? '?' : '&';
                url += arr.join('&');
            }
            location.href = url;
        } */
  },
  openPage(url, type, theme) {
    if (typeof type === "object") {
      theme = type;
      type = null;
    }
    this.sendPageAction(url, type, "openPage", theme);
  },
  pushPage(url, type, theme) {
    if (typeof type === "object") {
      theme = type;
      type = null;
    }
    this.sendPageAction(url, type, "pushPage", theme);
  },
  newPage(url, type, theme) {
    if (typeof type === "object") {
      theme = type;
      type = null;
    }
    this.sendPageAction(url, type, "newPage", theme);
  },
  returnPage() {
    this.send({ action: "returnPage" });
    /* if (location.hostname === 'localhost') {
            history.back();
        } */
  },
  closePage() {
    this.send({ action: "closePage" });
  },
  //条件关闭弹窗的协议
  closeTrialDialog() {
    this.send({ action: "closeTrialDialog" });
  },
  //注销交互协议 会在setTheme中重新启用
  cancellation() {
    this.send({ action: "cancellation" });
    return new Promise((resolve) => {
      setTimeout(resolve, 150);
    });
  },
  closeAllPages() {
    this.send({ action: "closeAllPages" });
  },
  setTheme(data = {}, options) {
    if (options) data = Object.assign({}, data, options);
    if (!data.themeName) {
      data = Object.assign({}, lastTitleBarTheme, data);
    }
    lastTitleBarTheme = data;

    let newData = { ...data };
    Object.keys(newData).forEach((key) => {
      if (typeof newData[key] === "function") newData[key] = newData[key]();
    });
    this.send({ action: "setTheme", data: newData });
  },
  /**
   *
   * @param {*} type lang 语言变化  webTheme 主题变化
   */
  setLastTheme(type) {
    if (!lastTitleBarTheme) return;
    if (type === "lang") {
      this.setTheme(lastTitleBarTheme);
      return;
    }
    let themeName = lastTitleBarTheme.themeName;
    let newTheme = titleBarTheme[themeName]();
    Object.keys(lastTitleBarTheme).forEach((key) => {
      if (type === "webTheme") {
        if (
          key.startsWith("rightButton") ||
          (!key.endsWith("Color") && "statusBarStyle" !== key)
        ) {
          newTheme[key] = lastTitleBarTheme[key];
        }
      }
    });
    this.setTheme(newTheme);
  },
  setPageTitle(title) {
    this.send({ action: "setPageTitle", data: { title } });
  },
  message(activity, options, callback) {
    if (typeof options === "function") {
      callback = options;
      options = undefined;
    }
    let data = Object.assign({ activity }, options || {});
    this.send(
      {
        action: "message",
        data,
      },
      callback
    );
  },
  /**
   *
   * @param {*} statisticType 事件ID  需要MTA系统加上对应的 key
   * @param {*} optionalParmas 附加参数
   * @param {*} statisticValue app端没用未使用，暂定为 0
   * @param {*} activity  协议类型：webMTA、webMTAEnd或webMTABegin
   * @param {*} statisticKey  app端未使用，暂定为WEB
   */
  mta(
    statisticType,
    optionalParmas,
    statisticValue = "0",
    activity = "webMTA",
    statisticKey = "Web"
  ) {
    // if (!mtaKeyAllowCheck(statisticType)) return;
    let data = {
      activity,
      statisticType,
      statisticValue,
      optionalParmas,
      statisticKey,
    };
    this.send({
      action: "message",
      data,
    });
    return new Promise((resolve) => {
      setTimeout(resolve, 300);
    });
  },
  mtaBegin(statisticType, optionalParmas, statisticValue) {
    return this.mta(
      statisticType,
      optionalParmas,
      statisticValue,
      "webMTABegin"
    );
  },
  mtaEnd(statisticType, optionalParmas, statisticValue) {
    return this.mta(statisticType, optionalParmas, statisticValue, "webMTAEnd");
  },
  /**
   * 通过app埋点到ostrich平台
   * @param {} data  json
   */
  webOstrich(data) {
    this.message("webOstrich", {
      jsonObject: JSON.stringify(data),
    });
    return new Promise((resolve) => {
      setTimeout(resolve, 300);
    });
  },

  /**
   * 通过app埋点到qos
   * @param {} data  json
   */
  webQos(key, value = {}) {
    this.message("webQOS", {
      key,
      value: {
        time: Date.now(),
        ...value,
      },
    });
    return new Promise((resolve) => {
      setTimeout(resolve, 300);
    });
  },
  on(event, callback) {
    let bridge = window.WebViewJavascriptBridge;
    bridge && bridge.Events.on(event, callback);
  },

  off(event, callback) {
    let bridge = window.WebViewJavascriptBridge;
    bridge && bridge.Events.off(event, callback);
  },
};
